export enum AuthenticationType {
  Password = 0,
  Sso = 1,
  UserApi = 2,
  AuthRequest = 3,
  WebAuthn = 4,
}
